import { IUserRoleInterface } from '../interfaces/user-role-interface';

export class UserRole {
    id: string = '';
    translationKey: string = '';
    selected: boolean = false;

    constructor(query?: IUserRoleInterface) {
        if (query) {
            this.id = query.id;
            this.translationKey = query.translationKey;
            this.selected = query.selected;
        }
    }
}
